import { Subscriber } from 'rxjs';

export class ImportResponseEmitter<TResponse> {
  private subscriber: Subscriber<TResponse> | null = null;

  register(subscriber: Subscriber<TResponse>) {
    this.subscriber = subscriber;
  }

  emit(response: TResponse) {
    if (!this.subscriber) {
      return;
    }

    this.subscriber.next(response);
    this.subscriber.complete();
  }
}
